import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator, ValidatorFn} from '@angular/forms';
import {PasswordsService} from './passwords.service';

const OLD_PASSWORD = 'oldPassword';
const NEW_PASSWORD = 'newPassword';
const CONFIRMED_PASSWORD = 'confirmedPassword';

@Directive({
  selector: '[passwordGroupValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: PasswordGroupValidatorDirective, multi: true}]
})

export class PasswordGroupValidatorDirective implements Validator {

  @Input() hasOldPassword = true;

  constructor(private Password: PasswordsService) {
  }

  validate(control: AbstractControl): {[key: string]: any} {
    return passwordGroupValidator(this.Password, this.hasOldPassword)(control);
  }
}

export function passwordGroupValidator(Password: PasswordsService, hasOldPassword: boolean): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    const errors = {};

    if (hasOldPassword && isOldPasswordMissing(control)) {
      errors['oldMissing'] = true;
    }
    if (isNewPasswordMissing(control, hasOldPassword)) {
      errors['newMissing'] = true;
    }
    if (isPasswordInvalid(Password, control.get(NEW_PASSWORD))) {
      errors['newInvalid'] = true;
    }
    if (isConfirmedPasswordInvalid(control)) {
      errors['badConfirmation'] = true;
    }

    return errors;
  };
}

function isOldPasswordMissing(control: AbstractControl) {
  const oldPassword = control.get(OLD_PASSWORD);
  const newPassword = control.get(NEW_PASSWORD);

  return newPassword.value && !oldPassword.value;
}

function isNewPasswordMissing(control: AbstractControl, hasOldPassword: boolean) {
  const newPassword = control.get(NEW_PASSWORD);

  if (!hasOldPassword) {
    return !newPassword.value;
  }

  const oldPassword = control.get(OLD_PASSWORD);

  return oldPassword.value && !newPassword.value;
}

function isPasswordInvalid(Password: PasswordsService, password: AbstractControl) {
  return password.value && !Password.isValid(password.value);
}

function isConfirmedPasswordInvalid(control: AbstractControl) {
  const newPassword = control.get(NEW_PASSWORD);
  const confirmedPassword = control.get(CONFIRMED_PASSWORD);

  return newPassword.value !== confirmedPassword.value;
}
